// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-container[data-v-1481448a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100vh - 110px);\n}\n[dir] .chat-container[data-v-1481448a] {\n  border: 1px solid #eaeaea;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
